// extracted by mini-css-extract-plugin
export default {"helperText":"SafetyNotifications_helperText__vFXhI"};